import { reactive } from 'vue'
import storage from "@/common/storage"
import { loadUserMenu } from './menu'
import { OPERATOR_ROLE_ID,SITE_MANAGER_ROLE_ID,ADMIN_ROLE_ID } from "./default"
const key = "dandelion-token"
export const user = reactive({
  name:"",
  id:"",
  token:"",
  type:"",
  roleId:0,
  isMch:0,
  AgentCode:'',
  CodePath:'',
  FakeCoef:1,
})

export const userPathCode = ()=>  {
  return user.CodePath 
}
export const isOperator = ()=>{
  //return (user.type == 'operator' || user.roleId == SITE_MANAGER_ROLE_ID)&&(user.id != 64)
  return user.AgentCode != ''
}

export const userRole25 = ()=>  {
  if(user.roleId == 25){
    return true
  }else{
    return false
  }
}
export const userRole43 = ()=>  {//生产专用角色
  if(user.roleId == 43){
    return true 
  }else{
    return false
  }
}
export const userRole18 = ()=>  {
  if(user.roleId == 18){
    return true
  }else{
    return false
  }
}
export const notShowHome = ()=>  {
  if(user.roleId == 35){
    return true
  }else{
    return false
  }
}

export const isPath = ()=>{
  let type = false
  if(user.roleId == 14 || user.roleId == 25 || user.roleId == 26 || user.roleId == 18|| user.roleId == 28|| user.roleId == 30|| user.roleId == 39|| user.roleId == 44|| user.roleId == 45|| user.roleId == 46){
    type = true
  }else{
    type = false
  }
  return type
}

export const isKSGOperator = ()=>{
  if(user.AgentCode=='KSGX'){
    return true
  }else{
    return false
  }
}

export const isEnVersion = ()=>{
  if (storage.get('locale') == 'En') {
    return true
  }else{
    return false
  }
}
export const canRechargeBalance = ()=>{
  if(user.id==139){
    return true
  }else{
    return false
  }
}
export const isEboxOperator = ()=>{
  if(user.roleId == 25){
    return true
  }else{
    return false
  }
}
export const showOperator = ()=>{
  return user.id == 64
}

export const isAdmin = ()=>{
  return user.type == 'admin'
}

export const setUser = (token,id,name,roleId,isMch,AgentCode,CodePath,save = true,fakeCoef)=>{
  user.token = token
  user.id = id
  user.name = name
  user.isMch = isMch
  user.roleId = roleId
  user.AgentCode = AgentCode
  user.CodePath = CodePath
  user.FakeCoef = fakeCoef
  if(roleId == OPERATOR_ROLE_ID){
    user.type = "operator"
  }else if(roleId == ADMIN_ROLE_ID){
    user.type = "admin"
  }else{
    user.type = ""
  }
  if(save)storage.set(key,user)
  loadUserMenu(user.id)
}


//load user 
const userData = storage.get(key)

if(userData){
  setUser(userData.token,userData.id,userData.name,userData.roleId,userData.isMch,userData.AgentCode,userData.CodePath,false,userData.FakeCoef)
}
// console.log(JSON.stringify(user));